export const METERS_PER_KILOMETER = 1e3;
export const METERS_PER_MILE = 1609.344;
